import { importTemplate, loadTemplates, removeImported } from '../template/store'
import { button, el, heading, toast } from '../ui/dom'
import { navigate } from '../router'

export function settingsScreen(): HTMLElement {
  const templateList = el('div', { class: 'stack' })
  const refresh = () => {
    templateList.replaceChildren()
    for (const loaded of loadTemplates()) {
      templateList.append(
        el('div', { class: 'release-row' }, [
          el('div', { class: 'release-main' }, [
            el('p', { class: 'release-name', text: loaded.template?.title ?? loaded.fileName }),
            el('p', {
              class: loaded.error ? 'release-meta error' : 'release-meta',
              text:
                loaded.error ??
                `${loaded.bundled ? 'Built in' : 'Imported'} · v${loaded.template?.version ?? '?'}`,
            }),
          ]),
          loaded.bundled
            ? null
            : button('Remove', () => {
                removeImported(loaded.fileName)
                refresh()
                toast('Removed.')
              }, 'text'),
        ]),
      )
    }
  }
  refresh()

  // Markdown has no reliable MIME type across file pickers, so the picker stays
  // open and the parser decides whether the file is usable.
  const picker = el('input', { type: 'file', accept: '.md,text/markdown,text/plain', class: 'visually-hidden' })
  picker.addEventListener('change', () => {
    const file = picker.files?.[0]
    if (!file) return
    void file.text().then((source) => {
      try {
        const template = importTemplate(source)
        toast(`Imported ${template.title}.`)
        refresh()
      } catch (e) {
        toast(`Could not import: ${(e as Error).message}`)
      } finally {
        picker.value = ''
      }
    })
  })

  return el('div', { class: 'screen' }, [
    el('header', { class: 'app-bar' }, [
      button('Back', () => navigate('/'), 'text'),
      el('h1', { class: 'app-title', text: 'Settings' }),
    ]),
    heading('Form templates'),
    templateList,
    picker,
    button('Import a template', () => picker.click()),
    el('p', {
      class: 'muted',
      text: 'Signed releases are held on this device only. Nothing is uploaded, and this app has no server to upload to.',
    }),
  ])
}
